export default __webpack_public_path__ + "static/media/Lucifer.58a13840.png";